import React from "react"

export default (context) => {
  // const M = "admMedical."

  const header = (props) => {
    const { form } = props
    return (
      <section>
        <div className="d-flex align-items-center">
          <div
            style={{ backgroundImage: `url(${form.face || ""}),url(${require("../../assets/img/user.png")})` }}
            className="imgPlaceholder mr-4">
          </div>
          <h5>{`${form.name} ${form.last}`}</h5>
        </div>
      </section>
    ) 
  }

  const contacts = (props) => {
    const { form } = props
    return (
      <section>
        <div className="d-flex align-items-center mb-4">
          <div
            style={{ backgroundImage: `url(${form.contact1.face || ""}),url(${require("../../assets/img/user.png")})` }}
            className="imgPlaceholderShort mr-4">
          </div>
          <div>
            <h6>{`${form.contact1.name} ${form.contact1.last || ""}`}</h6>
            <div>{`${form.contact1.mail}`}</div>
            <div>{`${form.contact1.cel}`}</div>
          </div>
        </div>

        <div className="d-flex align-items-center">
          <div
            style={{ backgroundImage: `url(${form.contact2.face || ""}),url(${require("../../assets/img/user.png")})` }}
            className="imgPlaceholderShort mr-4">
          </div>
          <div>
            <h6>{`${form.contact2.name} ${form.contact2.last || ""}`}</h6>
            <div>{`${form.contact2.mail}`}</div>
            <div>{`${form.contact2.cel}`}</div>
          </div>
        </div>
      </section>
    ) 
  }

  return {
    config: {
      pageSize: 40,
      resource: "admInfirmary/patients",
      list: false
    },

    actions: {
      create: false,
      edit: true,
      delete: true,
      print: false,
      export: true,
      search: true
    },

    filter: {
      fields: [
        {
          name: "type",
          type: "hidden",
          value: "3"
        },
        {
          name: "userId",
          value: "",
          type: "select",
          label: "Alumno",
          opts: {
            style: 'float-label',
            searchOnline: true,
            path: "/admStudent/get?enrolled=-1&pick=true",
            withImg: true
          }
        },
        {
          name: "superSectionId",
          value: null,
          type: "select",
          label: "main.grade",
          opts: {
            style: 'float-label',
            path: "/admSuperSection/get?pick=true"
          }
        },
        {
          name: "sectionId",
          value: "",
          type: "select",
          label: "main.section",
          parent: "superSectionId",
          opts: {
            style: 'float-label',
            path: () => { return "/admSection/get?pick=true&parentId=" + context.state.formFilter.superSectionId }
          }
        }
      ],
      buttons: [
        {
          name: "btnFilter",
          label: "main.applyFilter",
          onClick: (ctx) => { ctx.btnAction('filter') }
        }
      ]
    },

    form: {
      setValuesBeforePost: (values) => {
        const {
          med_height,
          med_weight,
          med_blood,
          med_vaccines,
          med_vaccinesNo,
          med_allergies,
          med_allergiesList,
          med_insurance,
          med_policy,
          med_prefHospital,
          med_physicalCharacteristics
        } = values;
        
        const selectedValues = {
          med_height,
          med_weight,
          med_blood,
          med_vaccines,
          med_vaccinesNo,
          med_allergies,
          med_allergiesList,
          med_insurance,
          med_policy,
          med_prefHospital,
          med_physicalCharacteristics
        };
        return selectedValues
      },
      remapOne: (r) => {

        return r
      },
      fields: [
        {
          col: 12,
          name: "header",
          value: "",
          type: "component",
          opts: {
            component: header
          }
        },
        {
          name: "name",
          type: "hidden"
        },
        {
          name: "last",
          type: "hidden"
        },
        {
          name: "face",
          type: "hidden"
        },
        {
          col: 12,
          name: "tabs",
          value: "medicalInformation",
          type: "tabs",
          tabs: [
            {
              id: "medicalInformation",
              name: "Información Médica",
              fields: [
                {
                  col: 4,
                  name: "med_height",
                  type: "number",
                  label: "Talla (m)",
                  rules: "required|numeric",
                  opts: {
                    style: 'float-label'
                  }
                },
                {
                  col: 4,
                  name: "med_weight",
                  type: "number",
                  label: "Peso (kg)",
                  rules: "required|numeric",
                  opts: {
                    style: 'float-label'
                  }
                },
                {
                  col: 4,
                  name: "med_blood",
                  type: "text",
                  label: "Tipo de sangre",
                  rules: "required",
                  opts: {
                    style: 'float-label'
                  }
                },
                {
                  col: 12,
                  name: "med_vaccines",
                  value: false,
                  type: "switch",
                  label: "¿Vacunación obligatoria completa?",
                  opts: {
                    style: 'float-label'
                  }
                },
                {
                  col: 12,
                  name: "med_vaccinesNo",
                  value: "",
                  type: "text",
                  label: "Vacunación opcional",
                  opts: {
                    style: 'float-label'
                  }
                },
                {
                  col: 6,
                  name: "med_allergies",
                  value: false,
                  type: "switch",
                  label: "¿Es alérgico?",
                  opts: {
                    style: 'float-label'
                  }
                },
                {
                  col: 12,
                  name: "med_allergiesList",
                  type: "textarea",
                  label: "Especificación de alergias",
                  rules: "required",
                  opts: {
                    style: 'float-label'
                  },
                  renderIf: ctx => ctx.state.med_allergies
                },
                {
                  col: 12,
                  name: "med_physicalCharacteristics",
                  type: "textarea",
                  label: "Caracteristicas fisicas",
                  rules: "required",
                  opts: {
                    style: 'float-label'
                  }
                },
                {
                  col: 12,
                  name: "subtitle",
                  type: "label",
                  value: "<h5>Seguro Médico y Emergencia</h5>",
                  opts: {
                    style: 'float-label'
                  }
                },
                {
                  col: 6,
                  name: "med_insurance",
                  type: "text",
                  label: "Seguro de médico",
                  rules: "required",
                  opts: {
                    style: 'float-label'
                  }
                },
                {
                  col: 6,
                  name: "med_policy",
                  type: "text",
                  label: "Número de poliza",
                  rules: "required",
                  opts: {
                    style: 'float-label'
                  }
                },
                {
                  col: 6,
                  name: "med_prefHospital",
                  type: "text",
                  label: "Centro médico (hospital o clínica)",
                  rules: "required",
                  opts: {
                    style: 'float-label'
                  }
                }
              ]
            },
            {
              id: "basicInformation",
              name: "Datos Básicos",
              fields: [
                {
                  col: 6,
                  name: "mail",
                  value: null,
                  type: "text",
                  label: "main.email",
                  opts: {
                    style: 'float-label'
                  },
                  disabled: true
                },
                {
                  col: 6,
                  name: "cel",
                  value: null,
                  type: "text",
                  label: "main.cellPhone",
                  opts: {
                    style: 'float-label'
                  },
                  disabled: true
                },
                {
                  col: 6,
                  name: "role",
                  value: null,
                  type: "text",
                  label: "main.role",
                  opts: {
                    style: 'float-label'
                  },
                  disabled: true
                },
                {
                  col: 6,
                  name: "externalId",
                  value: null,
                  type: "text",
                  label: "main.externalId",
                  opts: {
                    style: 'float-label'
                  },
                  disabled: true
                },
                {
                  col: 6,
                  name: "sectionName",
                  value: null,
                  type: "text",
                  label: "main.sectionName",
                  opts: {
                    style: 'float-label'
                  },
                  disabled: true
                },
                {
                  col: 6,
                  name: "livewith",
                  value: null,
                  type: "text",
                  label: "main.liveWith",
                  opts: {
                    style: 'float-label'
                  },
                  disabled: true
                },
                {
                  col: 6,
                  name: "birthplace",
                  value: null,
                  type: "text",
                  label: "main.birthplace",
                  opts: {
                    style: 'float-label'
                  },
                  disabled: true
                },
                {
                  col: 6,
                  name: "language",
                  value: null,
                  type: "text",
                  label: "main.language",
                  opts: {
                    style: 'float-label'
                  },
                  disabled: true
                },
                {
                  col: 6,
                  name: "legalwith",
                  value: null,
                  type: "text",
                  label: L => `${L['main.liveWith']} (${L['main.other']})`,
                  opts: {
                    style: 'float-label'
                  },
                  disabled: true
                },
                {
                  col: 6,
                  name: "documenttype",
                  value: null,
                  type: "text",
                  label: "main.documentType",
                  opts: {
                    style: 'float-label'
                  },
                  disabled: true
                },
                {
                  col: 6,
                  name: "documentnumber",
                  value: null,
                  type: "text",
                  label: "main.documentNumber",
                  opts: {
                    style: 'float-label'
                  },
                  disabled: true
                },
                {
                  col: 6,
                  name: "address",
                  value: null,
                  type: "text",
                  label: "main.address",
                  opts: {
                    style: 'float-label'
                  },
                  disabled: true
                },
                {
                  col: 6,
                  name: "country",
                  value: null,
                  type: "text",
                  label: "main.country",
                  opts: {
                    style: 'float-label'
                  },
                  disabled: true
                },
                {
                  col: 6,
                  name: "state",
                  value: null,
                  type: "text",
                  label: "state",
                  opts: {
                    style: 'float-label'
                  },
                  disabled: true
                },
                {
                  col: 6,
                  name: "city",
                  value: null,
                  type: "text",
                  label: "main.district",
                  opts: {
                    style: 'float-label'
                  },
                  disabled: true
                },
                {
                  col: 6,
                  name: "district",
                  value: null,
                  type: "text",
                  label: "main.district",
                  opts: {
                    style: 'float-label'
                  },
                  disabled: true
                },
                {
                  col: 6,
                  name: "birthday",
                  value: null,
                  type: "text",
                  label: "main.birthdate",
                  opts: {
                    style: 'float-label'
                  },
                  disabled: true
                },
                {
                  col: 6,
                  name: "homephone",
                  value: null,
                  type: "text",
                  label: "main.phone",
                  opts: {
                    style: 'float-label'
                  },
                  disabled: true
                },
                {
                  col: 6,
                  name: "religion",
                  value: null,
                  type: "text",
                  label: "admUser.religion",
                  opts: {
                    style: 'float-label'
                  },
                  disabled: true
                }
              ]              
            },
            {
              id: "contactInformation",
              name: "Datos de Contacto",
              fields: [
                {
                  col: 12,
                  name: "header",
                  value: "",
                  type: "component",
                  opts: {
                    component: contacts
                  }
                },
                {
                  name: "contact1",
                  type: "hidden"
                },{
                  name: "contact2",
                  type: "hidden"
                },
              ]
            }
          ]
        },
      ]
    },

    columns: [
      {
        Header: "",
        accessor: "img",
        type: "img"
      },
      {
        Header: "main.name",
        accessor: "name"
      },
      {
        Header: "main.lastName",
        accessor: "last"
      },
      {
        Header: "main.externalId",
        accessor: "externalId"
      },
      {
        Header: `Tipo de sangre`,
        accessor: "med_blood"
      },
      {
        Header: `Peso (kg)`,
        accessor: "med_weight"
      },
      {
        Header: `Talla (m)`,
        accessor: "med_height"
      },
      {
        Header: `Alergias`,
        accessor: "med_allergiesList"
      },
    ]
  }
}